export const PRISMIC_CLI_USER_AGENT = "prismic-cli";
